// specifications
export const GET_SPECIFICATIONS_REQUEST = 'GET_SPECIFICATIONS_REQUEST';
export const GET_SPECIFICATIONS_SUCCESS = 'GET_SPECIFICATIONS_SUCCESS';
export const GET_SPECIFICATIONS_FAILURE = 'GET_SPECIFICATIONS_FAILURE';

export const CLEAR_SPECIFICATIONS = 'CLEAR_SPECIFICATIONS';
